import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.data.length > 0)
    ? (_openBlock(), _createBlock($setup["BannerSwiper"], {
        key: 0,
        items: $setup.data,
        width: $setup.swipeWidth,
        height: $setup.swipeHeight,
        "box-padding": $setup.boxPadding,
        "border-radius": $setup.swipeSpace,
        "image-field": "cover",
        "image-fit": "fill",
        "show-detail-button": $setup.app_name == 'vi',
        onChange: $setup.swiperChange
      }, null, 8 /* PROPS */, ["items", "width", "height", "border-radius", "show-detail-button"]))
    : _createCommentVNode("v-if", true)
}